"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardPhotoBodyMixin = void 0;
var _styledComponents = require("styled-components");
/** @class PropertyCardPhotoBodyMixin */
/** @method */
var PropertyCardPhotoBodyMixin = /*#__PURE__*/(0, _styledComponents.css)(["grid-column:1 / -1;grid-row:1 / -1;"]);
exports.PropertyCardPhotoBodyMixin = PropertyCardPhotoBodyMixin;